import { render, staticRenderFns } from "./call_filter.vue?vue&type=template&id=422b4fa9&scoped=true&"
import script from "./call_filter.vue?vue&type=script&lang=js&"
export * from "./call_filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422b4fa9",
  null
  
)

export default component.exports